module.exports = __webpack_public_path__ + "static/img/hs_bot1.93af875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/hs_bot1.png
// module id = +IhY
// module chunks = 1